import { useMedicalTextIssues } from "./useMedicalTextIssues";
import { useIssueComments } from "./useIssueComments";

export const useIssuesAndComments = (medicalTextExampleId?: string, selectedIssueId?: string) => {
  const issuesHook = useMedicalTextIssues(medicalTextExampleId);
  const commentsHook = useIssueComments(selectedIssueId);

  // Get active and resolved issues separately
  const activeIssues = issuesHook.issues.filter((issue) => issue.status === "active");
  const resolvedIssues = issuesHook.issues.filter((issue) => issue.status === "resolved");

  // Wrap createIssue to return a promise for better error handling
  const createIssue = async (data: any) => {
    console.log("useIssuesAndComments: Creating issue with data:", data);

    return new Promise((resolve, reject) => {
      issuesHook.createIssue(data, {
        onSuccess: (result) => {
          console.log("useIssuesAndComments: Issue created successfully:", result);
          resolve(result);
        },
        onError: (error) => {
          console.error("useIssuesAndComments: Failed to create issue:", error);
          reject(error);
        },
      });
    });
  };

  return {
    // Issues
    issues: issuesHook.issues,
    activeIssues,
    resolvedIssues,
    isLoadingIssues: issuesHook.isLoading,
    issuesError: issuesHook.error,
    createIssue,
    isCreatingIssue: issuesHook.isCreatingIssue,
    resolveIssue: issuesHook.resolveIssue,
    isResolvingIssue: issuesHook.isResolvingIssue,
    reopenIssue: issuesHook.reopenIssue,
    isReopeningIssue: issuesHook.isReopeningIssue,

    // Comments
    comments: commentsHook.comments,
    isLoadingComments: commentsHook.isLoading,
    commentsError: commentsHook.error,
    createComment: commentsHook.createComment,
    isCreatingComment: commentsHook.isCreatingComment,
  };
};
